import { UserDashboard } from '../../components/dashboard/UserDashboard';

export default function ClientDashboard(): React.JSX.Element {
  return <UserDashboard role="client" title="Client dashboard" description="Your profile and care request." />;
}
